/* eslint-disable import/no-cycle */
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { RootState } from "../store";

import { SearchHistoryTypes, UserTypes } from "../../types";
export type JoinAsType = "DEFENDAANT" | "THIRD_PARTY";
export type ThirdPartyType = "DEFENDANT" | "PLAINTIFF";
export interface GlobalState {
  caseDetailsModal: boolean;
  caseDetails: SearchHistoryTypes | null; // both comes with the same data types

  selectedUser: UserTypes | null;
  joinAs: JoinAsType;
  thirdPartyType: ThirdPartyType;
  showSubmitModal: boolean;
  showAppealModal: boolean;
}

const initialState: GlobalState = {
  caseDetailsModal: false,
  caseDetails: null,

  selectedUser: null,
  joinAs: "DEFENDAANT",
  thirdPartyType: "DEFENDANT",
  showSubmitModal: false,
  showAppealModal: false,
};

export const GlobalSlice = createSlice({
  initialState,
  name: "globalstate",
  reducers: {
    setSelectedCaseDetails: (
      state,
      action: PayloadAction<SearchHistoryTypes | null>,
    ) => {
      state.caseDetails = action.payload;
    },

    setCaseDetailModal: (state, action) => {
      state.caseDetailsModal = action.payload;
    },

    setSelectedUser: (state, action: PayloadAction<UserTypes>) => {
      state.selectedUser = action.payload;
    },
    setJoinAs: (state, action: PayloadAction<JoinAsType>) => {
      state.joinAs = action.payload;
    },
    setThirdPartyType: (state, action: PayloadAction<ThirdPartyType>) => {
      state.thirdPartyType = action.payload;
    },
    setSubmitModal: (state, action: PayloadAction<boolean>) => {
      state.showSubmitModal = action.payload;
    },
    setAppealModal: (state, action: PayloadAction<boolean>) => {
      state.showAppealModal = action.payload;
    },
  },
});

export const {
  setSelectedCaseDetails,
  setCaseDetailModal,

  setSelectedUser,
  setJoinAs,
  setThirdPartyType,
  setSubmitModal,
  setAppealModal,
} = GlobalSlice.actions;

export const selectCase = (state: RootState) => state.globalstate.caseDetails;
export const openCaseModal = (state: RootState) =>
  state.globalstate.caseDetailsModal;

export const selectSelectedUser = (state: RootState) =>
  state.globalstate.selectedUser;
export const selectShowAppealModal = (state: RootState) =>
  state.globalstate.showAppealModal;
export const selectJoinAs = (state: RootState) => state.globalstate.joinAs;
export const selectSubmitModal = (state: RootState) =>
  state.globalstate.showSubmitModal;
export const selectThirdPartyType = (state: RootState) =>
  state.globalstate.thirdPartyType;

export const GlobalReducer = GlobalSlice.reducer;
